// « Compléter avec Matthieu » (T-242d) — onglet Conformité. Matthieu LIT les pièces et documents déjà reçus et PROPOSE ; l'humain VALIDE chaque
// proposition (une par une, aperçu + source citée) ; OmniHub EXÉCUTE. Aucun modèle n'est appelé ici, aucun montant n'est calculé,
// rien n'est écrit sans clic. Une proposition refusée ne revient pas. Mêmes cartes que « Parler à Matthieu » (source unique).
import { useState } from "react";
import { Sparkles } from "lucide-react";
import { OhStatusNote } from "../../../components/ui/oh-charte";
import Bouton from "../../omnihub/communication/boutonBureau";
import { CarteAction } from "../../omnihub/communication/ParlerAMatthieu";
import * as api from "../../omnihub/communication/matthieuApi";

const EN_ATTENTE = ["proposee", "corrigee"];
const muted = { color: "var(--oh-text-muted)", fontSize: 13, margin: 0 };
const detail = (e, defaut) => (typeof e?.detail === "string" ? e.detail : defaut);

const pluriel = (n, un, plusieurs) => `${n} ${n > 1 ? plusieurs : un}`;

export function resumeBilan(b) {
  if (!b) return "";
  const morceaux = [];
  if (b.pieces_proposees) morceaux.push(pluriel(b.pieces_proposees, "pièce à rattacher", "pièces à rattacher"));
  if (b.champs_proposes) morceaux.push(pluriel(b.champs_proposes, "champ à compléter", "champs à compléter"));
  if (b.demande_proposee) morceaux.push("une demande au client");
  return morceaux.length ? `Matthieu propose : ${morceaux.join(", ")}.` : "Rien de nouveau à proposer.";
}

export function CompleterAvecMatthieu({ dossierId, onApplied }) {
  const [etat, setEtat] = useState({ occupe: false, erreur: null, echange: null, bilan: null });

  const analyser = async () => {
    setEtat((e) => ({ ...e, occupe: true, erreur: null }));
    try {
      const r = await api.completerDossier(dossierId);
      setEtat({ occupe: false, erreur: null, echange: r.echange, bilan: r.bilan });
    } catch (e) {
      setEtat((x) => ({ ...x, occupe: false, erreur: detail(e, "L'analyse du dossier n'a pas pu être faite.") }));
    }
  };

  const recharger = async () => {
    try {
      const r = await api.lireEchange("dossier", dossierId);
      setEtat((x) => ({ ...x, echange: r.echange }));
    } catch (e) {
      setEtat((x) => ({ ...x, erreur: detail(e, "La conversation n'a pas pu être rechargée.") }));
    }
  };

  const actions = (etat.echange?.actions || []).filter((a) => EN_ATTENTE.includes(a.etat) || a.etat === "executee" || a.etat === "echec");
  const nbAValider = actions.filter((a) => EN_ATTENTE.includes(a.etat)).length;

  return (
    <div data-testid="completer-matthieu" className="space-y-2">
      <div className="flex flex-wrap items-center gap-2">
        <Bouton type="secondaire" data-testid="completer-matthieu-lancer" disabled={etat.occupe || !dossierId} onClick={analyser}>
          <span className="inline-flex items-center gap-2"><Sparkles className="w-4 h-4" aria-hidden="true" />{etat.occupe ? "Analyse en cours…" : "Compléter avec Matthieu"}</span>
        </Bouton>
        <p style={muted} data-testid="completer-matthieu-aide">
          {etat.bilan ? resumeBilan(etat.bilan) : "Matthieu cherche les pièces et valeurs déjà reçues et vous les propose. Vous validez chacune."}
        </p>
      </div>
      {etat.erreur && <OhStatusNote variant="error" role="alert" data-testid="completer-matthieu-erreur">{etat.erreur}</OhStatusNote>}
      {etat.echange && actions.length > 0 && (
        <section className="space-y-2" aria-label="Propositions pour compléter le dossier" data-testid="completer-matthieu-propositions">
          <p style={muted}>{nbAValider > 0 ? `${pluriel(nbAValider, "proposition à valider", "propositions à valider")}.` : "Toutes les propositions sont traitées."}</p>
          {actions.map((a) => (
            <CarteAction
              key={a.id}
              echangeId={etat.echange.id}
              a={a}
              occupe={etat.occupe}
              onVue={(r) => setEtat((x) => ({ ...x, echange: r.echange }))}
              onErreur={(msg, perime) => { setEtat((x) => ({ ...x, erreur: msg })); if (perime) recharger(); }}
              onExecutee={() => onApplied?.()}
            />
          ))}
        </section>
      )}
      {etat.echange && etat.bilan && actions.length === 0 && (
        <p style={muted} data-testid="completer-matthieu-rien">Aucune proposition en attente pour ce dossier.</p>
      )}
    </div>
  );
}

export default CompleterAvecMatthieu;
